import Vue from "vue";
import Vuetify, { VTextField } from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi"
  },
  theme: {
    themes: {
      dark: {
        primary: "#0b2472",
        secondary: "#ffde2d",
        anchor: "#ed2024",
        success: "#00C853",
        background: "#edffea"
      },
      light: {
        primary: "#44444b",
        secondary: "#ffde2d",
        anchor: "#ed2024",
        success: "#00C853",
        background: "#edffea"
      }
    }
  },
  components: {
    VTextField
  }
});
